// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-date-picker__header-label.active,.el-date-picker__header-label:hover,.el-date-table td.available:hover,.el-date-table td.today span,.el-picker-panel__icon-btn:hover{color:var(--primary-500)!important}.el-date-table td.current:not(.disabled) span{background-color:var(--primary-500)!important}.el-date-editor.el-input,.el-date-editor.el-input__inner{width:100%}.el-select-dropdown__item.selected{color:var(--primary-500)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
